import CryptoJS from 'crypto-js';

const secretKeyString = (import.meta as any).env?.VITE_ENCRYPTION_KEY; // Exactly 32 bytes
if (!secretKeyString) {
  throw new Error('VITE_ENCRYPTION_KEY is not set');
}
const secretKey = CryptoJS.enc.Utf8.parse(secretKeyString);

export const encryptData = (data: any) => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey, { iv: iv }).toString();
  return iv.toString(CryptoJS.enc.Hex) + ':' + ciphertext;
};

export const decryptData = (ciphertext: string) => {
  const [ivHex, encryptedText] = ciphertext.split(':');
  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey, { iv: iv });
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

// Decrypt a single value (string) instead of JSON object
export const decryptValue = (ciphertext: string): string => {
  const [ivHex, encryptedText] = ciphertext.split(':');
  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey, { iv: iv });
  return bytes.toString(CryptoJS.enc.Utf8);
};
